var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubstancePainterLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "29.800000000000004 10.600000000000001 146.7 141.20000000000002",
    xmlns: "http://www.w3.org/2000/svg",
    width: 2238,
    height: 2500,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#e1262f"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 94.5,
    cy: 19.8,
    rx: 9.2,
    ry: 9.2,
    transform: "rotate(-80.781 94.51 19.759)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162,
    cy: 137.3,
    r: 14.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.2,
    cy: 137.3,
    r: 6.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.5 38.7c-31 0-56.1 25.1-56.1 56.1s25.1 56.1 56.1 56.1 56.1-25.1 56.1-56.1-25.1-56.1-56.1-56.1zM56.5 73l37.9-21.9L132.2 73v19.8l-17.4-5.6v-4.1L94.4 71.3l-15 8.7 52.8 16.9v19.8l-37.9 21.9-37.9-21.8V96.9l17.5 5.5v4.1l20.4 11.8 15.2-8.8-53-16.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubstancePainterLogo);
export default __webpack_public_path__ + "static/media/SubstancePainterLogo.9a52664e8f66348617f208d25f5b9752.svg";
export { ForwardRef as ReactComponent };